export default __webpack_public_path__ + "static/media/ethdash.b38c4187.gif";